/* eslint-disable func-names */


interface IMessageEventObject {
    event: string;
    handler(payload: IMessageHandlerPayload): any;
    data: any;
}

interface IMessageHandlerPayload {
    data: any;
    message: any;
}

export class MessageEventUtil {
    eventCallbacks: IMessageEventObject[];

    constructor() {
        this.eventCallbacks = [];
        this.addMessageCallback(
            '*', {},
            (payload: any) => { console.log('MessageHandlerReceive', payload); },
        );
        window.addEventListener('message', (e) => {
            this.eventCallbacks.forEach((cb) => {
                const data = (function (raw) {
                    try {
                        return JSON.parse(raw);
                    } catch (err) {
                        return false;
                    }
                }(e.data));
                if (!data) return;
                if (cb.event === '*') {
                    cb.handler({
                        data: cb.data,
                        message: data,
                    });
                }
                if (cb.event !== data.event) return;
                cb.handler({
                    data: cb.data,
                    message: data,
                });
            });
        }, false);
    }

    addMessageCallback(event: string, data: any, handler: (payload: IMessageHandlerPayload) => void) {
        this.eventCallbacks.push({ event, data, handler });
    }
}
